var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "底部导航详情",
        visible: _vm.visible,
        "with-header": true,
        size: "500px",
        "before-close": _vm.handleClose,
        direction: "rtl",
        "custom-class": "bottom-nav-drawer",
      },
      on: { close: _vm.handleClose },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "drawer-content",
        },
        [
          _c("div", { staticClass: "info-section" }, [
            _c("div", { staticClass: "section-title" }, [
              _c("div", { staticClass: "blue-line" }),
              _c("span", [_vm._v("基本信息")]),
            ]),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("入口：")]),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.detailData.jumpPage)),
              ]),
            ]),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("名称：")]),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.detailData.name)),
              ]),
            ]),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("生效时间：")]),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.detailData.updateTime)),
              ]),
            ]),
            _c("div", { staticClass: "info-item images-row" }, [
              _c("span", { staticClass: "label" }, [_vm._v("图片：")]),
              _c("div", { staticClass: "image-container" }, [
                _vm.detailData.imgUrl
                  ? _c(
                      "div",
                      { staticClass: "image-item" },
                      [
                        _c("el-image", {
                          staticStyle: { width: "80px", height: "80px" },
                          attrs: {
                            src: _vm.detailData.imgUrl,
                            "preview-src-list": [_vm.detailData.imgUrl],
                            fit: "contain",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.detailData.optImgUrl
                  ? _c(
                      "div",
                      { staticClass: "image-item" },
                      [
                        _c("el-image", {
                          staticStyle: { width: "80px", height: "80px" },
                          attrs: {
                            src: _vm.detailData.optImgUrl,
                            fit: "contain",
                            "preview-src-list": [_vm.detailData.optImgUrl],
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "info-section" }, [
            _c("div", { staticClass: "section-title" }, [
              _c("div", { staticClass: "blue-line" }),
              _c("span", [_vm._v("修改日志")]),
            ]),
            _vm.detailData.logList && _vm.detailData.logList.length > 0
              ? _c("div", { staticClass: "log-timeline" }, [
                  _c(
                    "div",
                    { staticClass: "timeline-container" },
                    _vm._l(_vm.detailData.logList, function (log, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "timeline-item" },
                        [
                          _c("div", { staticClass: "timeline-left" }, [
                            _c("div", { staticClass: "timeline-dot" }),
                            index < _vm.detailData.logList.length - 1
                              ? _c("div", { staticClass: "timeline-line" })
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "timeline-content" }, [
                            _c("div", { staticClass: "log-header" }, [
                              _c("span", { staticClass: "log-operator" }, [
                                _vm._v(_vm._s(log.updatePerson)),
                              ]),
                              _c("span", { staticClass: "log-date" }, [
                                _vm._v(_vm._s(log.updateTime)),
                              ]),
                            ]),
                            _c("div", { staticClass: "log-detail" }, [
                              _c("div", [
                                _vm._v("生效时间：" + _vm._s(log.updateTime)),
                              ]),
                              _c(
                                "div",
                                { staticClass: "log-images" },
                                [
                                  log.imgUrl
                                    ? _c("el-image", {
                                        staticStyle: {
                                          width: "60px",
                                          height: "60px",
                                        },
                                        attrs: {
                                          src: log.imgUrl,
                                          fit: "contain",
                                          "preview-src-list": [log.imgUrl],
                                        },
                                      })
                                    : _vm._e(),
                                  log.optImgUrl
                                    ? _c("el-image", {
                                        staticStyle: {
                                          width: "60px",
                                          height: "60px",
                                        },
                                        attrs: {
                                          src: log.optImgUrl,
                                          fit: "contain",
                                          "preview-src-list": [log.optImgUrl],
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "line-height": "18px" } },
                                [_vm._v(_vm._s(log.name))]
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _c("div", { staticClass: "no-data" }, [
                  _vm._v(" 暂无修改记录 "),
                ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }